import src from "IMAGE";
export default { src, width: 1839, height: 868, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAR0lEQVR42j3NSw4AQQQEUFu/xlnq/nebpmMWwpMoJCJQFXR395lVFcw8pqpCZg4iAu2uNZ1zLmyuzAzP/nyLOnrfbLwI/7sP1R8K+ZEs0hoAAAAASUVORK5CYII="};
